import $ from 'jquery';

export function initAlert() {

    const globalContainer = document.getElementById('global-alert-container');

    if (globalContainer) {
        // Check if there are any alerts for this post id, and add them to the page if so
        const params = new URLSearchParams({
            action: 'get_page_alerts',
            post: globalContainer.dataset.post,
        });

        //fetch alert data
        fetch(`${site_data.WP_AJAX}?${params}`)
            .then(response => response.json())
            .then(response => {
                if (!response.success) {
                    throw new Error('Unable to get page alerts data');
                }

                //check if there are alerts
                if (response.markup.global_alert || response.markup.in_page_alert) {
                    //insert global alerts
                    if (response.markup.global_alert) {
                        globalContainer.innerHTML = response.markup.global_alert;
                    }

                    const $alert = $('.alert-bar');
                    $alert.slideDown();

                    // Init click events
                    const $closeAlertBtn = $('.alert-bar__close');
                    $closeAlertBtn.on('click', function (e) {
                        e.preventDefault();
                        //Fade out message text and close button
                        $(this).closest('.alert-bar').find('.container').addClass("fade");
                        //Slide up message
                        $(this).closest('.alert-bar').delay(250).slideUp();
                        // persist the dismissal in a cookie
                        document.cookie = $(this).data('alert-cookie');
                    });
                }
            })
            //todo error logging here
            .catch(error => console.log(error));
    }
}